import { DeliveryOption } from '../../../lib/types/communication.types';

// Schema version for the persisted multi-draft store (compose-panel.drafts). Bump when
// IStoredDraft/IComposePanelFields changes incompatibly; mismatched drafts are dropped on load.
export const DRAFTS_VERSION = 1;

// Schema version for the persisted last-used test recipients (compose-panel.test-recipients).
// Bump when ITestRecipients changes incompatibly; a mismatched envelope is dropped on load.
export const TEST_RECIPIENTS_VERSION = 1;
export const DRAFT_AUTOSAVE_MS = 2000;

// DOM id on the compose <form>; lets the focus-on-error effect scope its
// invalid-field lookup to this form (see FocusFirstInvalidField).
export const COMPOSE_FORM_ID = 'communication-compose-form';

export const DELIVERY_OPTION_ORDER: DeliveryOption[] = [
  DeliveryOption.EMAIL_ONLY,
  DeliveryOption.SMS_ONLY,
  DeliveryOption.EMAIL_PREFERRED,
  DeliveryOption.SMS_PREFERRED,
  DeliveryOption.BOTH
];
